import { render } from "./SubProductGroupProductForm.vue?vue&type=template&id=38b6d381&scoped=true"
import script from "./SubProductGroupProductForm.vue?vue&type=script&lang=js"
export * from "./SubProductGroupProductForm.vue?vue&type=script&lang=js"

import "./SubProductGroupProductForm.vue?vue&type=style&index=0&id=38b6d381&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b6d381"]])

export default __exports__